import { processFeedRequest, clearFeedItems } from "@tuqqi/web";
import { createRequestActions } from "@tuqqi/common/build";
import { feedItemsActionTypes } from "@tuqqi/web/dist/actions/feed-items-actions/feedItemsActions";

export function dispatchDataToNewUIStore(data, dispatch){
    dispatch(clearFeedItems())
    const feedItems = processFeedRequest(dispatch)(data)
    dispatch(createRequestActions(feedItemsActionTypes).success(feedItems))
}
